export default __webpack_public_path__ + "static/media/video-loader.16c02c8c.gif";